import './modules/_toggle-state';
import './modules/_primary-header';
import './modules/_aos-animation';
import './modules/_home-expertise';
import './modules/_home-bulle-slider';
import './modules/_lazyload-video';
import './modules/_client-interactivite';
import './modules/_contact-form';
import './modules/_agence-team.ts';
import './modules/_chiffre-count.ts';
/*
	BEWARE
	when you update the scripts, you need to copy the bundle generated in convert it in babel compiler (https://babeljs.io/repl).
	Than move the transpiled version to application/assets/legacy.js
	the lagacy file is loaded in layout-footer.twig
	This fix is required as far as we support IE11
*/
